import { Grid, useMediaQuery } from '@material-ui/core'
import React from 'react'
import FlexView from 'react-flexview/lib'
import { ReactComponent as Motorcycle } from '../../../../assets/motorcycle.svg'
import { SkyInformationPopover } from '../../../Core/Popover/SkyPopover'

const classNames = require('classnames')

const Line = ({ title, label, tooltip }) => {
  if (!label) return <div />

  return (
    <FlexView className="space-between margin-bottom-small">
      <FlexView vAlignContent={'center'}>
        <div className="text-body gray">{title}</div>
        {tooltip && (
          <SkyInformationPopover style={{ fontSize: '0.9rem' }}>
            <div className="text-small">{tooltip}</div>
          </SkyInformationPopover>
        )}
      </FlexView>
      <div className="text-small gray">{label}</div>
    </FlexView>
  )
}

export const VehiclePlanSummary = ({ vehicle, options, offerCart }) => {
  const isMobile = !useMediaQuery((theme) => theme.breakpoints.up('md'))

  const getLabelOfValue = (name) => {
    let value = offerCart[vehicle.id].coverages[name]
    let found = options[name].filter((item) => item.value == value)[0]
    if (!found) return { label: '' }
    return found
  }

  const getCoverageTooltip = (coverageName) => {
    let value = options[coverageName]
    return value && value.length > 1 ? value[0].tooltip : undefined
  }

  const getVehicleTitle = () => {
    return `${vehicle.make} ${vehicle.model}`
  }

  const getVehicleCoverageContents = () => {
    return (
      <Grid item xs={12} md={10}>
        {[
          {
            key: 'physical_damage_comprehensive',
            title: 'Comprehensive',
          },
          { key: 'physical_damage_collision', title: 'Collision' },
          {
            key: 'physical_damage_options',
            title: 'Physical Damage',
          },
          {
            key: 'uninsured_motorist_property_damage',
            title: 'UM Property Damage',
          },
          {
            key: 'mechanical_breakdown',
            title: 'Mechanical Breakdown',
          },
          { key: 'funeral_expense', title: 'Funeral Expense' },
          // {key: "trailer", title: "Trailer Coverage"},
          {
            key: 'rental_reimbursement',
            title: 'Rental Reimbursement',
          },
          {
            key: 'roadside_assistance',
            title: 'Roadside Assistance',
          },
          // {key: "volunteer_community_service", title: "Volunteer Community Service"},
        ]
          .sort((a, b) => {
            return getLabelOfValue(a.key).label < getLabelOfValue(b.key).label
              ? -1
              : 1
          })
          .map((item) => (
            <Line
              key={item.key}
              tooltip={getCoverageTooltip(item.key)}
              title={item.title}
              label={getLabelOfValue(item.key).label}
            />
          ))}
      </Grid>
    )
  }

  return (
    <>
      {isMobile ? (
        <Grid container alignItems="center" spacing={3}>
          <Grid item xs={2}>
            <FlexView hAlignContent={'left'} vAlignContent={'center'}>
              <Motorcycle className="medium-icon" />
            </FlexView>
          </Grid>
          <Grid item xs={10}>
            <div className="text-body blue bold">{getVehicleTitle()}</div>
          </Grid>
          {getVehicleCoverageContents()}
        </Grid>
      ) : (
        <Grid container spacing={3}>
          <Grid item xs={12} md={2}>
            <FlexView hAlignContent={'center'} vAlignContent={'center'} column>
              <Motorcycle
                className={classNames(
                  { 'big-icon': !isMobile },
                  { 'big-icon': isMobile }
                )}
              />
              <div className="text-body blue bold textcenter">
                {getVehicleTitle()}
              </div>
            </FlexView>
          </Grid>
          {getVehicleCoverageContents()}
        </Grid>
      )}
    </>
  )
}
